import classNames from 'classnames';
import React from 'react';
const Loading = (props) => {
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: classNames('loader', { full: !props.inline }, 'visible') },
            React.createElement("span", { className: "loader--ring" }),
            React.createElement("span", { className: "loader--ring" }),
            React.createElement("span", { className: "loader--ring" }),
            React.createElement("span", { className: "loader--ring" }))));
};
export default Loading;
